/* Perfume Gyaan — native localStorage wishlist. No app. Persists per-browser. */
(function(){
  var KEY='pg_wishlist_v1';
  function read(){try{return JSON.parse(localStorage.getItem(KEY)||'[]');}catch(e){return [];}}
  function write(a){try{localStorage.setItem(KEY,JSON.stringify(a));}catch(e){}}
  function has(h){return read().indexOf(h)>-1;}
  function count(){return read().length;}

  window.pgWishList=read;
  window.pgWishHas=has;

  window.pgWishToggle=function(handle,btn){
    if(!handle)return;
    var a=read(),i=a.indexOf(handle),on;
    if(i>-1){a.splice(i,1);on=false;}else{a.push(handle);on=true;}
    write(a);
    if(btn)btn.classList.toggle('on',on);
    syncBadges();
    // reflect on any other buttons for the same handle
    document.querySelectorAll('.wish[data-handle="'+cssEsc(handle)+'"]').forEach(function(b){b.classList.toggle('on',on);});
    if(window.pgWishOnChange)window.pgWishOnChange(handle,on);
    return on;
  };
  window.pgWishRemove=function(handle){
    var a=read(),i=a.indexOf(handle);if(i>-1){a.splice(i,1);write(a);syncBadges();}
  };
  function cssEsc(s){return (window.CSS&&CSS.escape)?CSS.escape(s):s.replace(/"/g,'\\"');}

  function syncBadges(){
    var n=count();
    document.querySelectorAll('[data-wish-count]').forEach(function(el){
      el.textContent=n; el.style.display=n>0?'':'none';
    });
  }
  function markButtons(){
    document.querySelectorAll('.wish[data-handle]').forEach(function(b){
      b.classList.toggle('on',has(b.getAttribute('data-handle')));
    });
  }
  document.addEventListener('DOMContentLoaded',function(){markButtons();syncBadges();});
  // re-sync when cards inject later (ajax load-more)
  window.pgWishSync=function(){markButtons();syncBadges();};
})();
